export default {
    timeoutMouseStop: 0,
    timeout: 0,

    initListenerEvents() {
        const mouseStopDelay = 1000;

        document.addEventListener('mousemove', e => {
            clearTimeout(this.timeout);
            clearTimeout(this.timeoutMouseStop);
            this.timeout = setTimeout(() => {
                var mouseStopEvent = new CustomEvent('mousestop', {
                    detail: {clientX: e.clientX, clientY: e.clientY, obj: e},
                    bubbles: true,
                    cancelable: true
                });
                e.target.dispatchEvent(mouseStopEvent);
            }, mouseStopDelay);
        });

        document.getElementById('starzplayer').addEventListener('mousestop', event => {
            var customEvent = new CustomEvent('hide', {event: event, bubbles: true, cancelable: true});
            this.timeoutMouseStop = setTimeout(() => Array.from(document.querySelectorAll('[data-mouseenter="0"]')).map(x => {
                x.removeAttribute('data-mouseenter');
                x.dispatchEvent(customEvent);
      
                clearTimeout(this.timeout);
                clearTimeout(this.timeoutMouseStop);
                return true;
            }), 4000);
        });
    },

    tracker(callback) {
        const mouseenter = (el) => () => el.setAttribute('data-mouseenter', 1);
        const mouseleave = (el) => () => el.setAttribute('data-mouseenter', 0);
        Array.from(document.querySelectorAll('[data-is-visible="1"]')).map(el => {
            el.removeEventListener('mouseenter', mouseenter(el), false);
            el.removeEventListener('mouseleave', mouseleave(el), false);
            el.addEventListener('mouseenter', mouseenter(el));
            el.addEventListener('mouseleave', mouseleave(el));
            el.addEventListener('hide', () => {
                clearTimeout(this.timeout);
                clearTimeout(this.timeoutMouseStop);
                callback();
            });
        });
    },

    register(callback) {
        this.tracker(callback);
    }
};



// WEBPACK FOOTER //
// ./src/modules/idle_controls_tracker/idle_controls_tracker.js